import React from 'react';
import { Button } from 'react-bootstrap';
import SearchableSelect from '../common/SearchableSelect';

export const BulkActionBanner = ({
  selectedIds,
  accounts,
  plTypes,
  bsTypes = [],
  payees,
  classes,
  bulkCategory,
  setBulkCategory,
  bulkPayee,
  setBulkPayee,
  bulkClass,
  setBulkClass,
  handleBulkCategorize,
  postingFilter = 'pending',
  handleBulkAction
}) => {
  if (selectedIds.length === 0) return null;

  return (
    <div className="card mb-3 p-2 bg-light border-primary">
      <div className="d-flex align-items-center justify-content-between">
        <div className="d-flex align-items-center">
          <span className="mr-3 small font-weight-bold text-primary">{selectedIds.length} selected</span>
          
          <SearchableSelect
            options={[
              { value: 'Uncategorized', label: 'Uncategorized' },
              ...accounts.filter(a => plTypes.includes(a.type) || bsTypes.includes(a.type)).map(a => ({ value: a.name, label: a.name, sublabel: a.type }))
            ]}
            value={bulkCategory}
            onChange={e => setBulkCategory(e.target.value)}
            placeholder="-- Assign Category / Transfer --"
            className="mr-2"
            style={{ width: '240px' }}
          />

          <SearchableSelect
            options={payees ? payees.filter(p => p.isActive).map(p => ({ value: p._id, label: p.name, sublabel: p.type })) : []}
            value={bulkPayee}
            onChange={e => setBulkPayee(e.target.value)}
            placeholder="-- Assign Payee --"
            className="mr-2"
            style={{ width: '180px' }}
          />

          <SearchableSelect
            options={classes ? classes.filter(c => c.isActive).map(c => ({ value: c._id, label: c.name })) : []}
            value={bulkClass}
            onChange={e => setBulkClass(e.target.value)}
            placeholder="-- Assign Class --"
            className="mr-2"
            style={{ width: '180px' }}
          />

          <Button variant="primary" size="sm" onClick={() => handleBulkCategorize()}>Apply</Button>
        </div>

        <div className="d-flex align-items-center" style={{ gap: '8px' }}>
          {postingFilter === 'pending' && (
            <>
              <Button 
                variant="success" 
                size="sm" 
                className="font-weight-bold" 
                onClick={() => handleBulkAction('post')}
              >
                <i className="fas fa-check mr-1"></i> Post Selected
              </Button>
              <Button 
                variant="outline-danger" 
                size="sm" 
                className="font-weight-bold" 
                onClick={() => handleBulkAction('exclude')}
              >
                <i className="fas fa-ban mr-1"></i> Exclude Selected
              </Button>
            </>
          )}
          {postingFilter === 'posted' && (
            <Button 
              variant="outline-danger" 
              size="sm" 
              className="font-weight-bold" 
              onClick={() => handleBulkAction('unpost')}
            >
              <i className="fas fa-undo mr-1"></i> Unpost Selected
            </Button>
          )}
          {postingFilter === 'excluded' && (
            <Button 
              variant="outline-info" 
              size="sm" 
              className="font-weight-bold" 
              onClick={() => handleBulkAction('restore')}
            >
              <i className="fas fa-trash-restore mr-1"></i> Restore Selected
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};
